import type { StreamerData } from '../../../mocks/streamers/schema';

interface Props {
  streamer: StreamerData;
  state: 'minimal' | 'compact' | 'expanded';
  onToggle: () => void;
}

const statusLabel: Record<StreamerData['status'], string> = {
  LIVE: 'Live',
  AWAY: 'Away',
  OFFLINE: 'Offline',
};

export default function StreamCircle(props: Props) {
  const label = () => `${props.streamer.displayName} - ${statusLabel[props.streamer.status]}`;

  return (
    <button
      class="streamer-circle"
      type="button"
      aria-label={label()}
      title={label()}
      data-state={props.state}
      data-status={props.streamer.status.toLowerCase()}
      onClick={props.onToggle}
    >
      <img src={props.streamer.avatar} alt="" aria-hidden="true" />
    </button>
  );
}
